import { isEmpty } from "@swiggy-private/js-utils";
import { CartItemWithUUID } from "@swiggy-private/cart-types";
import { CARD_PLACEHOLDER_IMAGE_ID } from "@cart-ui/constants/CrossSellM2";

export const separateCardsOnImageId = (cards: CartItemWithUUID[]) => {
    const { cardWithImages, cardWithoutImages } = cards.reduce(
        (acc, item) => {
            if (isEmpty(item?.cloudinaryImageId)) {
                acc.cardWithoutImages.push(item);
            } else {
                acc.cardWithImages.push(item);
            }
            return acc;
        },
        { cardWithImages: [] as CartItemWithUUID[], cardWithoutImages: [] as CartItemWithUUID[] },
    );

    const crossSellM2Items = [...cardWithImages, ...cardWithoutImages];

    return crossSellM2Items;
};

export const getImageId = (imageId?: string) => {
    const finalImageId = isEmpty(imageId) ? CARD_PLACEHOLDER_IMAGE_ID : imageId;

    return finalImageId;
};
